import { Card, CardContent, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import MaterialUiButton from "../Buttons/MaterialUiButton/MaterialUiButton";

// This component has a css file you can use to get ride of the borders of Googles Info window component.
// To enable the css, the parent of the map component needs to have the className "custom-css"

export default function PopUpZoneContent(props) {
  const { asset, zone } = props;
  const { assetId = "", tag } = asset || {};
  const { name = "", xyz = {} } = zone || {};
  const { x = 0, y = 0 } = xyz;
  const history = useHistory();

  return (
    <Grid
      className="map-info-window"
      container
      sx={{
        minHeight: "7rem",
        minWidth: "20rem",
        maxWidth: "20rem",
        padding: ".75rem",
        position: "relative",
      }}
    >
      {/* Top 25% red background overlay */}
      <Grid
        item
        sx={{
          background:
            "linear-gradient(to bottom, #002843, rgba(255, 255, 255, 0.1))", // Gradient from #002843 to a slight white
          // borderRadius: '1rem 1rem 0 0', // Optional: rounded corners
          height: "30%",
          left: 0,
          position: "absolute", // Overlay it on top
          top: 0,
          width: "100%",
          zIndex: 1, // Ensure it sits behind everything
        }}
      />

      {/* Zone Name */}
      <Grid
        item
        size={10}
        sx={{
          zIndex: 2,
        }}
      >
        {/* Zone Name */}
        <Card>
          <CardContent
            sx={{
              paddingBottom: ".5rem !important",
              padding: ".3rem",
            }}
          >
            <Grid container>
              <Grid item size={12} sx={{ textAlign: "left" }}>
                <Typography
                  noWrap
                  variant="h5"
                  sx={{ textDecoration: "underline" }}
                >
                  {name}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* Zone Info */}
      <Grid item size={12}>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", marginTop: "0.5rem" }}
        >
          {name} is located at coordinates: ({x}, {y})
        </Typography>
      </Grid>

      {/* Tag location - if tag is present */}
      {tag ? (
        <Grid item size={12}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", marginTop: "0.5rem" }}
          >
            {tag ? `${tag} is located in zone: ${name}` : null}
          </Typography>
          <MaterialUiButton
            color="submit"
            fullWidth
            label="View Asset History"
            onClick={()=>{
              history.push(`/assetSnapshot/${assetId}`, { from: "/" });
            }}
            sx={{ fontSize: "14px", marginTop:'.5rem' }}
            variant="text"
          />
        </Grid>
      ) : null}
    </Grid>
  );
}
